// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1_wgB","cls2":"SuggestionReason-cls2_MLc SuggestionReason-cls1_wgB"};